/* Ionix — avaliacoes na PDP: paginacao, ordenacao, filtro e foto em tela cheia */
(function () {
  var POR_PAGINA = 10;

  function iniciar(raiz) {
    if (raiz.dataset.pronto) return;
    raiz.dataset.pronto = '1';

    var lista = raiz.querySelector('.ionrv__list');
    var pager = raiz.querySelector('.ionrv__pager');
    var vazio = raiz.querySelector('.ionrv__empty');
    var cards = Array.prototype.slice.call(raiz.querySelectorAll('.ionrv__card'));
    var ordem = cards.slice();
    var pagina = 1;
    var soFoto = false;

    function visiveis() {
      return soFoto ? ordem.filter(function (c) { return c.dataset.foto === '1'; }) : ordem;
    }

    function pintar() {
      var vis = visiveis();
      var total = Math.max(1, Math.ceil(vis.length / POR_PAGINA));
      if (pagina > total) pagina = total;
      cards.forEach(function (c) { c.hidden = true; });
      vis.slice((pagina - 1) * POR_PAGINA, pagina * POR_PAGINA)
         .forEach(function (c) { c.hidden = false; lista.appendChild(c); });
      if (vazio) vazio.hidden = vis.length !== 0;
      montarPager(total);
    }

    function botao(rotulo, alvo, atual, passo) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ionrv__page' + (passo ? ' ionrv__page--step' : '');
      if (passo) { b.innerHTML = rotulo; b.setAttribute('aria-label', passo); }
      else { b.textContent = rotulo; }
      if (atual) b.setAttribute('aria-current', 'true');
      if (alvo === null) { b.disabled = true; }
      else b.addEventListener('click', function () {
        pagina = alvo; pintar();
        raiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      return b;
    }

    function montarPager(total) {
      if (!pager) return;
      pager.innerHTML = '';
      if (total <= 1) return;
      var seta = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
      pager.appendChild(botao(seta, pagina > 1 ? pagina - 1 : null, false, 'Previous'));
      var nums = [];
      for (var i = 1; i <= total; i++) {
        if (i === 1 || i === total || Math.abs(i - pagina) <= 1) nums.push(i);
        else if (nums[nums.length - 1] !== '...') nums.push('...');
      }
      nums.forEach(function (n) {
        if (n === '...') {
          var s = document.createElement('span');
          s.className = 'ionrv__dots'; s.textContent = '…'; pager.appendChild(s);
        } else pager.appendChild(botao(String(n), n, n === pagina, ''));
      });
      var prox = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
      pager.appendChild(botao(prox, pagina < total ? pagina + 1 : null, false, 'Next'));
    }

    var seletor = raiz.querySelector('.ionrv__sort');
    if (seletor) seletor.addEventListener('change', function () {
      var v = seletor.value;
      if (v === 'high') ordem = cards.slice().sort(function (a, b) { return b.dataset.nota - a.dataset.nota; });
      else if (v === 'low') ordem = cards.slice().sort(function (a, b) { return a.dataset.nota - b.dataset.nota; });
      else if (v === 'pics') ordem = cards.slice().sort(function (a, b) { return b.dataset.foto - a.dataset.foto; });
      else ordem = cards.slice();
      pagina = 1; pintar();
    });

    var filtro = raiz.querySelector('.ionrv__filter');
    if (filtro) filtro.addEventListener('click', function () {
      soFoto = !soFoto;
      filtro.setAttribute('aria-pressed', soFoto ? 'true' : 'false');
      pagina = 1; pintar();
    });

    var faixa = raiz.querySelector('.ionrv__strip');
    if (faixa) {
      raiz.querySelectorAll('.ionrv__arrow').forEach(function (a) {
        a.addEventListener('click', function () {
          faixa.scrollBy({ left: (a.classList.contains('ionrv__arrow--prev') ? -1 : 1) * 324, behavior: 'smooth' });
        });
      });
      var ajustar = function () {
        var sobra = faixa.scrollWidth - faixa.clientWidth - 4;
        var p = raiz.querySelector('.ionrv__arrow--prev'), n = raiz.querySelector('.ionrv__arrow--next');
        if (p) p.hidden = faixa.scrollLeft <= 4;
        if (n) n.hidden = faixa.scrollLeft >= sobra;
      };
      faixa.addEventListener('scroll', ajustar);
      window.addEventListener('resize', ajustar);
      ajustar();
    }

    /* foto em tela cheia */
    var fotos = Array.prototype.slice.call(raiz.querySelectorAll('[data-full]'));
    var urls = [], atual = 0;
    var box = document.createElement('div');
    box.className = 'ionrv-box'; box.hidden = true;
    box.innerHTML = '<button type="button" class="ionrv-box__close" aria-label="Close">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
      '<button type="button" class="ionrv-box__nav ionrv-box__nav--prev" aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>' +
      '<img alt="Customer photo">' +
      '<button type="button" class="ionrv-box__nav ionrv-box__nav--next" aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></button>';
    document.body.appendChild(box);
    var alvo = box.querySelector('img');

    function abrir(i) { atual = (i + urls.length) % urls.length; alvo.src = urls[atual]; box.hidden = false; document.body.style.overflow = 'hidden'; }
    function fechar() { box.hidden = true; alvo.removeAttribute('src'); document.body.style.overflow = ''; }
    fotos.forEach(function (el) {
      var u = el.dataset.full;
      if (urls.indexOf(u) === -1) urls.push(u);
      el.addEventListener('click', function () { abrir(urls.indexOf(u)); });
    });
    box.querySelector('.ionrv-box__close').addEventListener('click', fechar);
    box.querySelector('.ionrv-box__nav--prev').addEventListener('click', function () { abrir(atual - 1); });
    box.querySelector('.ionrv-box__nav--next').addEventListener('click', function () { abrir(atual + 1); });
    box.addEventListener('click', function (e) { if (e.target === box) fechar(); });
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') fechar();
      if (e.key === 'ArrowLeft') abrir(atual - 1);
      if (e.key === 'ArrowRight') abrir(atual + 1);
    });

    pintar();
  }

  function ligar() { document.querySelectorAll('.ionrv').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar);
  else ligar();
  document.addEventListener('shopify:section:load', ligar);
})();
